import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "font-awesome/css/font-awesome.min.css";
import { FaTimes } from "react-icons/fa";

const ViewBioData = ({ show, handleClose }) => {
  const location = useLocation();
  const bioData = location.state?.bioDataProbs || {};
  const navigate = useNavigate();
  console.log(bioData, "bioData>>>>>>>>>>>>..");

  return (
    <div className="modal-overlay bio_data_view  admin_modal_preview ">
      <div className="custom-modal-content">
        <form className="m-0">
          <div className="modal_preview_title text-left">
            <h2 className="pb-3 m-auto ps-0">Board Members Preview</h2>
          </div>
          <div className="custom-form-group d-block closepreview text-right">
            <button
              type="button"
              className="custom-btn-cancel"
              onClick={() => navigate("/bio-data-table")}
            >
              <FaTimes />
            </button>
          </div>
          <div className="custom-form-group modalimage mb-2">
            <label className="custom-label">Member Name</label>
            <span>:</span>
            <div
              className="modal_preview_img"
              style={{
                display: "flex",
                alignItems: "center",
                padding: "20px ",
              }}
            >
              <img
                className="text-left m-0"
                src={bioData.imagePath}
                alt="Preview"
                style={{ marginBottom: "10px" }}
              />
            </div>
          </div>

          <div className="custom-form-group mb-2">
            <label className="custom-label">Member Name</label>
            <span>:</span>
            <h5 style={{ color: "black", margin: "5px 0" }}>
              {bioData.memberName}
            </h5>
          </div>

          <div className="custom-form-group">
            <label className="custom-label">Organization Name</label>
            <span>:</span>
            <p style={{ color: "black", margin: "5px 0" }}>
              {bioData.organizationName}
            </p>
          </div>
          <div className="custom-form-group">
            <label className="custom-label">Designation</label>
            <span>:</span>
            <h5 style={{ color: "black", margin: "5px 0" }}>
              {bioData.designation}
            </h5>
          </div>
          <div className="custom-form-group">
            <label className="custom-label">Energy Title</label>
            <span>:</span>
            <h5 style={{ color: "black", margin: "5px 0" }}>
              {bioData.energyTitle}
            </h5>
          </div>
          <div className="custom-form-group">
            <label className="custom-label">Energy SubTitle</label>
            <span>:</span>
            <h5 style={{ color: "black", margin: "5px 0" }}>
              {bioData.energySubTitle}
            </h5>
          </div>
          <div className="custom-form-group">
            <label className="custom-label">Energy Description</label>
            <span>:</span>
            <p style={{ color: "black", margin: "5px 0" }}>
              {bioData.energyDescription}
            </p>
          </div>
          <div className="custom-form-group">
            <label className="custom-label">Encourage Title</label>
            <span>:</span>
            <h5 style={{ color: "black", margin: "5px 0" }}>
              {bioData.encourageTitle}
            </h5>
          </div>
          <div className="custom-form-group">
            <label className="custom-label">Encourage SubTitle</label>
            <span>:</span>
            <h5 style={{ color: "black", margin: "5px 0" }}>
              {bioData.encourageSubTitle}
            </h5>
          </div>
          <div className="custom-form-group">
            <label className="custom-label">Encourage Description</label>
            <span>:</span>
            <p style={{ color: "black", margin: "5px 0" }}>
              {bioData.encourageDescription}
            </p>
          </div>
          <div className="custom-form-group">
            <label className="custom-label">Engaged Title</label>
            <span>:</span>
            <h5 style={{ color: "black", margin: "5px 0" }}>
              {bioData.engagedTitle}
            </h5>
          </div>
          <div className="custom-form-group">
            <label className="custom-label">Engaged SubTitle</label>
            <span>:</span>
            <h5 style={{ color: "black", margin: "5px 0" }}>
              {bioData.engagedSubTitle}
            </h5>
          </div>
          <div className="custom-form-group">
            <label className="custom-label">Engaged Description</label>
            <span>:</span>
            <p style={{ color: "black", margin: "5px 0" }}>
              {bioData.engagedDescription}
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ViewBioData;
